import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import { FormattedNumber } from 'react-intl'

import moment from 'moment'

import { ELO_RATING_TEXT } from 'helpers/i18n.jsx'

import { StatsTooltip } from '../../components'

import { CLAN_INFO_PANEL_CREATED_AT } from './constants.jsx'
import { STATS_TOOLTIPS_IDS } from '../StatsTooltip/constants.jsx'

import styles from './ClanInfoPanel.scss'

const ClanInfoPanel = (props) => {
    const { clan, stats, elo_leaderboards } = props
    const vehicleLevels = Object.keys(stats).sort((a, b) => b - a)

    const divisionsComponent = vehicleLevels.map(vehicle_level => {
        const divisionClassName = classNames(styles.division, styles[`division__${vehicle_level}`])
        const vehicleLevelInElo = leaderboard => leaderboard.vehicle_level === parseInt(vehicle_level)

        return (
            <div key={`rating-in-${vehicle_level}`} className={styles.divisionItem}>
                <div className={divisionClassName} data-tip data-for={STATS_TOOLTIPS_IDS[vehicle_level]}>
                    <FormattedNumber value={stats[vehicle_level].elo} />
                </div>
                <StatsTooltip
                    {...stats[vehicle_level]}
                    level={vehicle_level}
                    elo_details={elo_leaderboards.find(vehicleLevelInElo)}
                />
            </div>
        )
    })

    return (
        <div className={styles.base}>
            <div className={styles.background} />
            <div className={styles.clan}>
                <span className={styles.emblem} style={{ backgroundImage: `url(${clan.emblem})` }}/>
                <p className={styles.name}>{`[${clan.tag}] ${clan.name}`}</p>
                <p className={styles.date}>{CLAN_INFO_PANEL_CREATED_AT(moment(clan.created_at).format('LL'))}</p>
            </div>
            <div className={styles.details}>
                <div className={styles.ratings}>
                    <p className={styles.subtitle}>{ELO_RATING_TEXT}</p>
                    <div className={styles.divisions}>
                        {divisionsComponent}
                    </div>
                </div>
            </div>
        </div>
    )
}

ClanInfoPanel.propTypes = {
    clan: PropTypes.shape({
        tag: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        emblem: PropTypes.string.isRequired,
        created_at: PropTypes.number.isRequired,
    }).isRequired,
    // WGSH-2679 extend with new levels
    stats: PropTypes.shape({
        6: PropTypes.object.isRequired,
        8: PropTypes.object.isRequired,
        10: PropTypes.object.isRequired,
    }).isRequired,
    elo_leaderboards: PropTypes.array,
}

export default ClanInfoPanel



// WEBPACK FOOTER //
// ./containers/Stronghold/components/ClanInfoPanel/ClanInfoPanel.jsx